const filled = (value) => typeof value === 'string' && value.trim().length > 0;

const hasVenue = (value) => Boolean(value && (
  filled(value.name) || filled(value.hall_name) || filled(value.address)
));

/** Check only content that an enabled section would otherwise replace with a fallback. */
export function getMissingWebInviteDetails(invite) {
  const missing = new Set();
  const sections = invite?.sections || [];
  const hero = sections.find((section) => section.type === 'hero');
  const heroContent = hero?.content || {};
  const heroOverrides = hero?.overrides || {};

  if (hero) {
    if (!filled(heroOverrides.headline)) {
      if (hero.source_mode === 'custom') {
        missing.add('Hero: couple names or a custom headline');
      } else {
        if (!filled(heroContent.bride_name)) missing.add('Hero: bride name');
        if (!filled(heroContent.groom_name)) missing.add('Hero: groom name');
      }
    }
    if (!heroContent.start_date) missing.add('Hero: wedding date');
    const hasPersonalPhoto = filled(heroOverrides.image_url)
      || (hero.source_mode !== 'custom' && (
        filled(heroContent.couple_photo_url)
        || (heroContent.hero_media || []).some((item) => item?.visible !== false && filled(item?.url))
      ));
    if (!hasPersonalPhoto) missing.add('Hero: couple photo');
  }

  sections.forEach((section) => {
    const content = section.content || {};
    const overrides = section.overrides || {};
    switch (section.type) {
      case 'story':
        if (!filled(overrides.body) && (section.source_mode === 'custom' || !filled(content.description))) {
          missing.add('Our story: message');
        }
        break;
      case 'hosts':
        if (!filled(overrides.body) && !filled(content.bride_name) && !filled(content.groom_name)
          && !(content.host_names || []).some(filled)) missing.add('Meet the hosts: names');
        break;
      case 'itinerary':
        if (!content.items?.length) missing.add('Itinerary: events and timings');
        else content.items.forEach((item, index) => {
          if (!filled(item.name)) missing.add(`Itinerary item ${index + 1}: name`);
          if (!item.date) missing.add(`Itinerary item ${index + 1}: date`);
          if (!filled(item.start_time)) missing.add(`Itinerary item ${index + 1}: start time`);
        });
        break;
      case 'venue':
        if (!(content.venues || []).some(hasVenue)) missing.add('Venues: venue name or address');
        break;
      case 'map':
        if (!hasVenue(content.venue)) missing.add('Venue map: location');
        break;
      case 'gallery':
        if (!(content.images || []).length && !(overrides.image_urls || []).length) {
          missing.add('Gallery: your photos');
        }
        break;
      case 'custom':
        if (!filled(overrides.headline)) missing.add('Custom section: headline');
        if (!filled(overrides.body)) missing.add('Custom section: message');
        break;
      default:
        break;
    }
  });

  if (invite?.design?.music?.enabled && invite.design.music.track_id === 'custom'
    && !filled(invite.design.music.custom_audio_url)) missing.add('Music: custom audio file');
  return [...missing];
}
